import {PartialData, QueryParameters} from '@di-nxt/resource-container';
import {Config} from '../../config/types';

export const mockDataSourceResolver = <
  TData extends PartialData<TIdKey, any>,
  TParameters extends QueryParameters,
  TIdKey extends keyof TData
>(
  getConfig: () => Config,
  staticData: TData[],
  generatorFactory?: (
    getConfig: Config,
  ) => (parameters: TParameters) => TData[],
): TData[] | ((parameters: TParameters) => TData[]) => {
  if (
    getConfig().Api.Mock.Mode === 'generate' &&
    generatorFactory !== undefined
  ) {
    return generatorFactory(getConfig());
  }

  return staticData;
};
